import {
  Box,
  FormControl,
  FormControlLabel,
  MenuItem,
  Select,
  Switch,
  Typography,
} from '@mui/material';

import { useT } from '@/hooks';

import { EXPIRATION_OPTIONS } from '@/constants/market.constants';

const HEADING_FONT = 'var(--font-archivo), Archivo, sans-serif';

interface ExpirationSelectorProps {
  setExpiration: boolean;
  onExpirationToggle: (checked: boolean) => void;
  expirationValue: string;
  onExpirationValueChange: (value: string) => void;
}

export function ExpirationSelector({
  setExpiration,
  onExpirationToggle,
  expirationValue,
  onExpirationValueChange,
}: ExpirationSelectorProps) {
  const { t } = useT();
  return (
    <Box sx={{ mb: 2.5 }}>
      <FormControlLabel
        control={
          <Switch
            checked={setExpiration}
            onChange={(e) => onExpirationToggle(e.target.checked)}
            sx={{
              '& .MuiSwitch-switchBase.Mui-checked': {
                color: 'success.main',
              },
              '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                backgroundColor: 'success.main',
              },
            }}
          />
        }
        label={
          <Typography
            sx={{
              fontFamily: HEADING_FONT,
              fontSize: '0.875rem',
              fontWeight: 600,
              color: 'text.primary',
            }}
          >
            {t('trade.setExpiration', { defaultValue: 'Set Expiration' })}
          </Typography>
        }
      />
      {setExpiration && (
        <FormControl fullWidth size="small" sx={{ mt: 1.5 }}>
          <Select
            value={expirationValue}
            onChange={(e) => onExpirationValueChange(e.target.value)}
            sx={{
              fontSize: '0.875rem',
              borderRadius: '10px',
              bgcolor: 'background.default',
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'divider',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: 'divider',
              },
            }}
            MenuProps={{
              sx: { zIndex: 30000 },
            }}
          >
            {EXPIRATION_OPTIONS.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.value === 'end-of-day'
                  ? t('trade.endOfDay', { defaultValue: 'End of Day' })
                  : opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </Box>
  );
}
